// component
import SettingsIcon from '@mui/icons-material/Settings';
import MonitorIcon from '@mui/icons-material/Monitor';
import CategoryIcon from '@mui/icons-material/Category';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import HandymanIcon from '@mui/icons-material/Handyman';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import HandshakeIcon from '@mui/icons-material/Handshake';
import SellIcon from '@mui/icons-material/Sell';
import BadgeIcon from '@mui/icons-material/Badge';
import PlaceIcon from '@mui/icons-material/Place';
import ReceiptIcon from '@mui/icons-material/Receipt';

import { getProfile } from '../../../shared/auth/authService';
import { ROLES } from '../../../shared/auth/roles';

// Was ['MANAGER', 'BRANCH_MANAGER']; BRANCH_MANAGER is not a role the API
// issues, so it never matched and this was already MANAGER-only in practice.
const branchRoles = [ROLES.MANAGER];

/**
 * Build the sidebar for the signed-in user.
 *
 * This used to be a module-level constant computed from localStorage at import
 * time, so the sidebar kept whichever role was signed in when the bundle first
 * loaded — signing in as a different role showed the previous user's menu until
 * a hard reload. Callers invoke this during render instead.
 */
const getNavConfig = () => {
  const storedUser = getProfile() || {};
  const isManager = storedUser?.role && branchRoles.includes(storedUser.role);

  return (isManager && [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: <DashboardIcon />,
  },
  {
    title: 'Assets',
    path: '/dashboard/assets',
    icon: <MonitorIcon />,
  },
  {
    title: 'Transfers',
    path: '/dashboard/transfers',
    icon: <UnfoldMoreIcon />,
  },
  {
    title: 'Maintenance',
    path: '/maintenance/app',
    icon: <HandymanIcon />,
  },
  {
    title: 'Handovers',
    path: '/dashboard/handovers',
    icon: <HandshakeIcon />,
  },
  {
    title: 'Disposals',
    path: '/dashboard/disposals',
    icon: <SellIcon />,
  },
  {
    title: 'Settings',
    path: '/dashboard/settings',
    icon: <SettingsIcon />,
  },
]) ||
  (storedUser?.role === 'SERVICE_PROVIDER' && [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: <DashboardIcon />,
    },
    {
      title: 'Maintenance',
      path: '/dashboard/maintenance',
      icon: <HandymanIcon />,
    },
    {
      title: 'Settings',
      path: '/dashboard/settings',
      icon: <SettingsIcon />,
    },
  ]) || [
    {
      title: 'dashboard',
      path: '/dashboard/app',
      icon: <DashboardIcon />,
    },
    {
      title: 'Assets',
      path: '/dashboard/assets',
      icon: <MonitorIcon />,
    },
    {
      title: 'Transfers',
      path: '/dashboard/transfers',
      icon: <UnfoldMoreIcon />,
    },
    {
      title: 'Categories',
      path: '/dashboard/categories',
      icon: <CategoryIcon />,
    },
    {
      title: 'Branches',
      path: '/dashboard/branches',
      icon: <PlaceIcon />,
    },
    {
      title: 'Maintenance',
      path: '/maintenance/app',
      icon: <HandymanIcon />,
    },
    {
      title: 'Invoices',
      path: '/dashboard/invoices',
      icon: <ReceiptIcon />,
    },
    {
      // Counting and reconciling are two steps of one exercise now, so they
      // live on one screen rather than two disconnected menu entries.
      title: 'Audits',
      path: '/dashboard/audits',
      icon: <NoteAltIcon />,
    },
    {
      title: 'Handovers',
      path: '/dashboard/handovers',
      icon: <HandshakeIcon />,
    },
    {
      title: 'Disposals',
      path: '/dashboard/disposals',
      icon: <SellIcon />,
    },
    {
      title: 'Reports',
      path: '/dashboard/reports',
      icon: <AnalyticsIcon />,
    },
    {
      title: 'Users',
      path: '/dashboard/users',
      icon: <BadgeIcon />,
    },
    {
      title: 'Settings',
      path: '/dashboard/settings',
      icon: <SettingsIcon />,
    },
  ];
};

export default getNavConfig;
